<app-fd-dialog-shell
  [titulo]="MENSAJES.TITULO"
  [variante]="FD_DIALOG_VARIANTE.PREGUNTA"
  [ancho]="FD_DIALOG_ANCHO.PEQUENO"
  [visible]="visible()"
  [closable]="false"
  [labelConfirmar]="MENSAJES.LABEL_CONTINUAR"
  [labelCancelar]="MENSAJES.LABEL_CERRAR_SESION"
  (confirmar)="onContinuar()"
  (cancelar)="onCerrarSesion()">
  <p>
    {{ MENSAJES.MENSAJE_PREFIJO }}
    <strong>{{ tiempoFormateado() }}</strong>{{ MENSAJES.MENSAJE_SUFIJO }}
  </p>
</app-fd-dialog-shell>
